export default __webpack_public_path__ + "static/media/logo.65f8cdb7.png";